export function formatPriceHuf(value: number | null | undefined): string {
  if (value == null) return "—";
  return new Intl.NumberFormat("hu-HU", {
    style: "currency",
    currency: "HUF",
    maximumFractionDigits: 0,
  }).format(value);
}

export function formatArea(sqm: number | string | null | undefined): string {
  if (sqm == null) return "—";
  const num = typeof sqm === "string" ? Number.parseFloat(sqm) : sqm;
  if (Number.isNaN(num)) return "—";
  return `${num.toLocaleString("hu-HU")} m²`;
}

/** Human-readable file size (Hungarian formatting). Empty string when unknown. */
export function formatFileSize(bytes: number | null | undefined): string {
  if (bytes == null || !Number.isFinite(bytes) || bytes <= 0) return "";
  const mb = bytes / (1024 * 1024);
  if (mb >= 1) {
    return `${mb.toLocaleString("hu-HU", { maximumFractionDigits: 1 })} MB`;
  }
  return `${Math.max(1, Math.round(bytes / 1024))} KB`;
}

export function fileUrl(key: string | null | undefined): string {
  if (!key) return "";
  // Server returns either the public R2 URL via /api/files/* (proxied),
  // so here we just construct that path. If R2_PUBLIC_URL is configured,
  // the server's `publicFileUrl()` already returns absolute URLs that we
  // get via the project payload.
  return key.startsWith("http") ? key : `/api/files/${encodeURI(key)}`;
}
